import { render, staticRenderFns } from "./fkgl.vue?vue&type=template&id=925e10f0&scoped=true&"
import script from "./fkgl.vue?vue&type=script&lang=js&"
export * from "./fkgl.vue?vue&type=script&lang=js&"
import style0 from "./fkgl.vue?vue&type=style&index=0&id=925e10f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925e10f0",
  null
  
)

export default component.exports